import React from 'react';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import styles from './styles.scss';
import HelloModal from 'common/components/hello-modal';
import HfReactHelper from 'common/utils/hf-react-helper';
import { useSelector } from 'react-redux';

const messages = defineMessages({
  title: {
    id: '',
    description: 'Title for limit quota alert modal',
    defaultMessage: 'Exceeded signature request quota',
  },
  pricing: {
    id: '',
    description: 'text for limit modal that lets you view our plans at their respective price',
    defaultMessage: 'View plans',
  },
  close: {
    id: '',
    description: 'text for limit modal that lets you close the modal',
    defaultMessage: 'Close',
  },
});

const DocumentQuotaAlert: types.TriggerComponent = ({ onCancel, onSkip, stage }) => {
  // conditionally setting the trigger type because if this modal is triggered in the load
  // stage (the FileUploaderPage), it can be skipped and the request can still be created,
  // but when triggered on the submit stage (the ReviewPage), it cannot be skipped, since
  // creating a signature request isn't allowed if the user is out of documents
  const triggerType = stage === 'load' ? onSkip : onCancel;
  const intl = useIntl();
  const { isNewHsPlan, isTransactionalPlan } = useSelector(selectors.getFlags);
  const url = isNewHsPlan && isTransactionalPlan ? 'api/pricing' : 'info/pricing';
  const pricingUrl = HfReactHelper.urlHelper(url, 'hellosign');
  return (
    <HelloModal
      width='540px'
      scrollable={false}
      isOpen={true}
      onRequestClose={triggerType}
      buttons={[
        {
          type: 'secondary',
          text: intl.formatMessage(messages.close),
          onClick: triggerType,
        },
        {
          type: 'primary',
          text: intl.formatMessage(messages.pricing),
          buttonLink: pricingUrl,
          openInNewWindow: true,
        },
      ]}
      contentLabel={intl.formatMessage(messages.title)}
    >
      <div className={styles.quotaText}>
        <FormattedMessage
          id=""
          description="quota alert text for no remaining free documents"
          defaultMessage="Your current plan does not have any more document sends this billing cycle. You can still create a request, but won't be able to send it out until you have upgraded to a higher plan." />
        <br /><br />
        <FormattedMessage
          id=""
          description="quota alert sub text with information about request being saved as draft"
          defaultMessage="This request will be saved as a draft on the 'Documents' page and will need to be sent out manually after you upgrade." />
      </div>
    </HelloModal>
  );
};

DocumentQuotaAlert.needsTrigger = (state, _formik) => {
  const isHelloSign = !selectors.isHelloFax(state);
  const isAtDocumentLimit = selectors.isAtDocumentLimit(state);
  const isTemplateRequest = selectors.isTemplateRequest(state);
  const isEmbedded = selectors.isEmbedded(state);

  // check if it's not a template request & is also HelloSign
  // we don't show quota alerts for embedded requests
  return !isEmbedded && !isTemplateRequest && isHelloSign && isAtDocumentLimit;
};

export default DocumentQuotaAlert;
